import React, {useEffect, useState} from "react";
import {ApiEndPointFieldsProps} from "../../constants/AppConstants";
import {makeStyles} from "@mui/styles";
import {deepUpdate} from 'immupdate'
import {IntegrationApiOptionsFieldItem} from "./auth/IntegrationApiOptionsFieldItem";
import {ArrayToObject} from "../../helpers/objectHelpers";
import {AppField} from "../ui/AppField";
import Box from "@mui/material/Box";
import {AppButton} from "../ui/AppButton";

const useStyles = makeStyles(() => ({
    fieldRoot: {
        display: "flex",
        gap: 10,
        margin: "10px 0"
    },
    fieldActionBtn: {
        height: "43px",
        width: "43px",
        background: "#F2F2F2",
        borderRadius: 8,
        overflow: "hidden",
        cursor: "pointer",
        transition: "0.3s",
        "&:hover": {
            transform: "scale(1.1)"
        }
    },
    btn: {
        display: "flex",
        height: "100%",
        width: "100%",
        justifyContent: "center",
        alignItems: "center",
    },
}));

interface Props {
    readonly data: ApiEndPointFieldsProps[];
    readonly onChange: (data: ApiEndPointFieldsProps[]) => void
}

export function IntegrationApiOptionsFieldV2({data, onChange}: Props) {
    const classes = useStyles();
    const [fields, setFields] = useState<ApiEndPointFieldsProps[]>(data);
    const [newItemCode, setNewItemCode] = useState("");

    const handleAdd = (item: ApiEndPointFieldsProps) => {
        setFields(prev => [...prev, item])
    };
    const handleDelete = (id: number) => {
        setFields(prev => {
            const idx = prev.findIndex(item => item.id === id);
            return [...prev.slice(0, idx), ...prev.slice(idx + 1)];
        })
    };

    const handleUpdate = (id: number, data: ApiEndPointFieldsProps) => {
        setFields((prev:ApiEndPointFieldsProps[]) => {
            return deepUpdate(prev)
                .at(prev.findIndex(item => item.id === id))
                .abortIfUndef()
                .set(data);
        })
    };

    useEffect(() => {
        const savedFields = fields.filter(item => item.saved);
        const obj = ArrayToObject(savedFields);
        onChange(obj)
    }, [fields]);
    return (
        <div>
            {data &&
            fields?.map((item, index) => {
                return (
                    <IntegrationApiOptionsFieldItem
                        onDelete={handleDelete}
                        key={index + Math.random() * 20}
                        item={item}
                        onAdd={handleAdd}
                        onUpdate={handleUpdate}
                    />
                );
            })}

                <form onSubmit={(e) => {
                    e.preventDefault();
                    handleAdd({
                        code: newItemCode,
                        value: "",
                        saved: true,
                        id: Date.now()
                    });
                    setNewItemCode("")
                }} >
                    <Box sx={{display: "flex", gap: "15px", alignItems: "center"}}>
                    <AppField value={newItemCode} onChange={(e: any) => setNewItemCode(e.target.value)} name="code" placeholder="code" />
                    <AppButton type="submit" size="small">Add</AppButton>
                    </Box>
                </form>
        </div>
    );
}



